import axios from 'axios';

let prefix = "/admin-user"

/**
 * Admin account management.
 *
 * There is no password endpoint on purpose: a new admin is emailed a
 * set-password link and chooses their own, so this app never holds, sends or
 * asks for one.
 */
const AdminUserApi = {

	getAdminList(payload){
		return axios.get( prefix + "/list", {params: payload})
	},
	getAdminById(id, payload){
		return axios.get( prefix + "/get/" + id, {params: payload})
	},
	createAdmin(payload){
		return axios.post( prefix + "/create", payload)
	},
	updateAdmin(payload){
		return axios.post( prefix + "/update", payload)
	},
	setAdminActive(payload){
		return axios.post( prefix + "/set-active", payload)
	},
	resendInvite(payload){
		return axios.post( prefix + "/resend-invite", payload)
	},
	unlockAdmin(payload){
		return axios.post( prefix + "/unlock", payload)
	},

}

export default AdminUserApi;
